import classNames from 'classnames';
import styles from './Bundles.module.scss';
import TextBlock from '../TextBlock/TextBlock';
import SectionTitle from '../SectionTitle/SectionTitle';

const BundlesTable = ({ data, className }) => {
  const renderTableTd = (item, index) => {
    return (
      <div
        className={styles.table__td}
        key={index}
        itemScope
        itemType='https://schema.org/OfferCatalog'
      >
        {item?.text}
      </div>
    );
  };

  const renderTableColumn = (item, index) => {
    return (
      <div
        className={styles.table__column}
        key={index}
        itemScope
        itemType='https://schema.org/Offer'
      >
        <div className={styles.table__th}>{item?.title}</div>
        <div className={styles.table__values}>
          {item?.rows?.map(renderTableTd)}
        </div>
      </div>
    );
  };

  return (
    <div
      className={classNames(styles.table, className)}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {data?.left_card_title && (
        <SectionTitle
          titleModify={classNames(styles.table__title, 'title--large')}
          data-testid='section-title'
        >
          {data.left_card_title}
        </SectionTitle>
      )}
      {data?.left_card_description && (
        <TextBlock
          className={classNames(styles.table__text, 'text--large')}
          data-testid='text-block'
        >
          {data.left_card_description}
        </TextBlock>
      )}
      {data?.left_card_columns && (
        <div className={styles.table__inner}>
          {data?.left_card_columns?.map(renderTableColumn)}
        </div>
      )}
    </div>
  );
};

export default BundlesTable;
